import styled, { useTheme } from 'styled-components';
import { Heading2Text } from '../../../../components/Texts';
import ColorizedSpan from '../../../../components/Colorized';
import GiftCardsScroll from './GiftCardsScroll';
import { PHONE_MEDIA_QUERY } from '../../../../common/responsive';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: fit-content;
  min-height: 750px;
  gap: 30px;
  @media ${PHONE_MEDIA_QUERY} {
    min-height: unset;
    overflow: hidden;
    padding-top: 25px;
    padding-bottom: 25px;
  }
`;

const SubTitle = styled.p`
  font-size: 18px;
  font-weight: 400;
  color: ${({ theme }) => theme.text.title};
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
  @media ${PHONE_MEDIA_QUERY} {
    gap: 0px;
  }
`;

const TraditionalGiftCards = () => {
  const theme = useTheme();

  return (
    <Container>
      <TitleContainer>
        <Heading2Text style={{ color: theme.text.title }}>
          Most Popular <ColorizedSpan>Shops</ColorizedSpan>
        </Heading2Text>
      </TitleContainer>
      <GiftCardsScroll />
    </Container>
  );
};

export default TraditionalGiftCards;
